import React from 'react';
import { ApolloClient, InMemoryCache, ApolloProvider, gql, useQuery } from '@apollo/client';
import { Box, Typography, Card, CardContent, CircularProgress, Alert } from '@mui/material';

// Define the GraphQL query
const GET_OBSERVATION_QUERY = gql`
  query {
    observation(criteria:{sensor:"active-state"}) {
      observations {
        title
        content
      }
    }
  }
`;

const GetActiveState = ({ client, onLoad }) => {
    const { loading, error, data } = useQuery(
        GET_OBSERVATION_QUERY, 
        { 
            client,
            //Necessary to trigger oncompleted after refetch
            notifyOnNetworkStatusChange: true,
            onCompleted: data => {
                if (data?.observation?.observations?.[0]?.content) {
                    onLoad?.(JSON.parse(data.observation.observations[0].content));
                }
            },
            pollInterval: 15000 // Repoll every 15 seconds (15000 milliseconds)
        }
    );
}

export default GetActiveState;